/**
 * 我的便签接口（按登录账号隔离，数据落库到 user_note 表）
 */
import request from './request'

/**
 * 当前登录用户的便签列表（最新在前）
 * @param {string} userNo 当前登录账号
 */
export function listNotes(userNo) {
  return request.get('/note/list', { params: { userNo } })
}

/**
 * 新增一条便签
 * @param {{userId:number, userNo:string, title:string, content:string}} data
 */
export function saveNote(data) {
  return request.post('/note/save', data)
}

/**
 * 删除一条便签（只能删自己的）
 * @param {{id:number, userNo:string}} data
 */
export function deleteNote(data) {
  return request.get('/note/del', { params: data })
}
